module.exports = __webpack_public_path__ + "img/logIn-registration-mobile.16262f43.png";